var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "pim-product-table-list__content" },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "row" }, [
      _c("div", { staticClass: "pim-product-table-list__hr" }, [_c("hr")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }